"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerAmplificationAbilityHandler = exports.PowerAmplificationActorAbilityFactory = exports.PowerAmplificationAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class PowerAmplificationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PowerAmplification;
        this.__typeName = "PowerAmplification";
    }
}
exports.PowerAmplificationAbilityArgs = PowerAmplificationAbilityArgs;
let PowerAmplificationActorAbilityFactory = class PowerAmplificationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PowerAmplification", "AllAllies", 4);
    }
};
PowerAmplificationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PowerAmplification")
], PowerAmplificationActorAbilityFactory);
exports.PowerAmplificationActorAbilityFactory = PowerAmplificationActorAbilityFactory;
let PowerAmplificationAbilityHandler = class PowerAmplificationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                for (const ally of allies) {
                    container.applyBuff({
                        creatorId: ability.invokerId,
                        targetId: ally,
                        sequence,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new __1.LinkedEffectsEffectArgs([
                            new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Power, container.getPercentOfBaseAttributeScore(ally, 10, "Power")),
                            new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Focus, container.getPercentOfBaseAttributeScore(ally, 10, "Focus"))
                        ], false)
                    });
                }
            }
        });
    }
};
PowerAmplificationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PowerAmplification)
], PowerAmplificationAbilityHandler);
exports.PowerAmplificationAbilityHandler = PowerAmplificationAbilityHandler;
